// extracted by mini-css-extract-plugin
export var anchor = "_2x-0";
export var discard = "_2x-4";
export var muiTooltipTooltip = "_2x-6";
export var notificationBar = "_2x-3";
export var saveButtonHoverSlotWrapper = "_2x-5";
export var show = "_2x-2";
export var spacer = "_2x-1";